/* ============================================================
   KG Paint D3 — skin-wrap animation driver

   Pixel-matched to the standalone references:
   Desktop → D3 Typographic + Paint (9s, 440×460): sk2*
   Mobile  → Biosignaling Paint Loop Mobile (6s, 334×452): m*

   Geometry is always the reference coords × (panelH / REF_H).
   Seal zip uses the same cubic-bezier(.5, 0, .18, 1) as the HTML.
   Typographic word lighting stays on CSS so it stays in sync.
   ============================================================ */
(function () {
  var BLUE = '#0047ff';
  var GREY_LINE = 'rgba(20,16,8,0.3)';
  var BARRIER_LINE = 'rgba(20,16,8,0.34)';
  var CAP1_GREY = 'rgba(20,16,8,0.5)';
  var CAP3_GREY = 'rgba(20,16,8,0.4)';
  var MOBILE_MQ = '(max-width: 767px)';

  /* Desktop reference panel (sk-v2) */
  var D = {
    refH: 460,
    surfaceY: 96,
    barrierY: 200,
    tipStart: -14,
    tipEnd: 442,
    sigAboveH: 110,
    tipLeft: '81.59%',
    sigLeft: '81.36%',
    tipSize: 12,
    tipMargin: -5,
    sealH: 5,
    sealMarginTop: -2,
    sealTipSize: 10,
    sealGlow: '0 0 22px rgba(0,71,255,.8)',
    sealTipGlow: '0 0 0 5px rgba(0,71,255,.22),0 0 16px 2px rgba(0,71,255,.7)',
    tipGlow: '0 0 0 5px rgba(0,71,255,.16)',
    loopMs: 9000
  };

  /* Mobile reference panel */
  var M = {
    refH: 452,
    surfaceY: 104,
    barrierY: 214,
    tipStart: -16,
    tipEnd: 452,
    sigAboveH: 120,
    tipLeft: '86.83%',
    sigLeft: '86.83%',
    tipSize: 11,
    tipMargin: -4.5,
    sealH: 4,
    sealMarginTop: -1.5,
    sealTipSize: 8,
    sealGlow: '0 0 18px rgba(0,71,255,.75)',
    sealTipGlow: '0 0 0 4px rgba(0,71,255,.22),0 0 14px 2px rgba(0,71,255,.7)',
    tipGlow: '0 0 0 5px rgba(0,71,255,.16),0 0 14px 2px rgba(0,71,255,.5)',
    loopMs: 6000
  };

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  /* Exact CSS cubic-bezier(.5, 0, .18, 1) unit-bezier solver */
  function cubicBezierEase(x1, y1, x2, y2) {
    function sampleX(t) {
      return (
        3 * (1 - t) * (1 - t) * t * x1 +
        3 * (1 - t) * t * t * x2 +
        t * t * t
      );
    }
    function sampleY(t) {
      return (
        3 * (1 - t) * (1 - t) * t * y1 +
        3 * (1 - t) * t * t * y2 +
        t * t * t
      );
    }
    function sampleDX(t) {
      return (
        3 * (1 - t) * (1 - t) * x1 +
        6 * (1 - t) * t * (x2 - x1) +
        3 * t * t * (1 - x2)
      );
    }
    return function (x) {
      if (x <= 0) return 0;
      if (x >= 1) return 1;
      var t = x;
      for (var i = 0; i < 8; i++) {
        var xEst = sampleX(t) - x;
        var d = sampleDX(t);
        if (Math.abs(xEst) < 1e-6 || Math.abs(d) < 1e-6) break;
        t -= xEst / d;
        if (t < 0) t = 0;
        if (t > 1) t = 1;
      }
      var lo = 0;
      var hi = 1;
      for (var j = 0; j < 8; j++) {
        var x2est = sampleX(t);
        if (Math.abs(x2est - x) < 1e-6) break;
        if (x2est < x) lo = t;
        else hi = t;
        t = (lo + hi) / 2;
      }
      return sampleY(t);
    };
  }

  var easeSeal = cubicBezierEase(0.5, 0, 0.18, 1);

  /* stops: [[p, value, opacity], ...] — p is 0–100 */
  function sample(stops, p, easeFn) {
    if (p <= stops[0][0]) return { v: stops[0][1], o: stops[0][2] };
    if (p >= stops[stops.length - 1][0]) {
      var last = stops[stops.length - 1];
      return { v: last[1], o: last[2] };
    }
    for (var i = 0; i < stops.length - 1; i++) {
      var a = stops[i];
      var b = stops[i + 1];
      if (p >= a[0] && p <= b[0]) {
        var t = (p - a[0]) / (b[0] - a[0] || 1);
        if (easeFn) t = easeFn(t);
        return { v: lerp(a[1], b[1], t), o: lerp(a[2], b[2], t) };
      }
    }
    return { v: stops[0][1], o: stops[0][2] };
  }

  /* Linear color lerp for sk2Cap3 (CSS animation-timing-function: linear) */
  function sampleCap3(p) {
    var grey = CAP3_GREY;
    var white = '#ffffff';
    if (p <= 44) return grey;
    if (p < 48) {
      var t = (p - 44) / 4;
      return lerpColor(grey, white, t);
    }
    if (p <= 76) return white;
    if (p < 80) {
      var t2 = (p - 76) / 4;
      return lerpColor(white, grey, t2);
    }
    return grey;
  }

  function lerpColor(a, b, t) {
    var ca = parseColor(a);
    var cb = parseColor(b);
    return (
      'rgba(' +
      Math.round(lerp(ca[0], cb[0], t)) +
      ',' +
      Math.round(lerp(ca[1], cb[1], t)) +
      ',' +
      Math.round(lerp(ca[2], cb[2], t)) +
      ',' +
      (Math.round(lerp(ca[3], cb[3], t) * 1000) / 1000) +
      ')'
    );
  }

  function parseColor(c) {
    if (c.charAt(0) === '#') {
      var h = c.slice(1);
      if (h.length === 3) {
        return [
          parseInt(h[0] + h[0], 16),
          parseInt(h[1] + h[1], 16),
          parseInt(h[2] + h[2], 16),
          1
        ];
      }
      return [
        parseInt(h.slice(0, 2), 16),
        parseInt(h.slice(2, 4), 16),
        parseInt(h.slice(4, 6), 16),
        1
      ];
    }
    var m = c.match(/rgba?\(([^)]+)\)/);
    if (!m) return [0, 0, 0, 1];
    var p = m[1].split(',').map(function (x) {
      return parseFloat(x.trim());
    });
    return [p[0], p[1], p[2], p.length > 3 ? p[3] : 1];
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE_MQ).matches;
  }

  function measure(root, mobile) {
    var skin = root.querySelector('.kg-paint__skin');
    if (!skin) return null;
    var ref = mobile ? M : D;
    var panelH = skin.clientHeight || ref.refH;
    var panelW = skin.clientWidth || (mobile ? 334 : 440);
    var scale = panelH / ref.refH;

    return {
      skin: skin,
      cap1: root.querySelector('.kg-paint__cap--1'),
      cap3: root.querySelector('.kg-paint__cap--3'),
      ref: ref,
      scale: scale,
      panelH: panelH,
      panelW: panelW,
      surfaceY: ref.surfaceY * scale,
      barrierY: ref.barrierY * scale,
      band: (ref.barrierY - ref.surfaceY) * scale,
      tipStart: ref.tipStart * scale,
      tipEnd: ref.tipEnd * scale,
      sigAboveH: ref.sigAboveH * scale,
      sigBand: (ref.barrierY - ref.surfaceY) * scale,
      sigFull: (ref.tipEnd - ref.surfaceY) * scale
    };
  }

  /* ---------- Desktop sk2* paths (9s) — exact keyframe % ---------- */
  function desktopTip(m) {
    return [
      [0, m.tipStart, 0],
      [4, m.tipStart, 1],
      [13, m.surfaceY, 1],
      [22, m.barrierY, 1],
      [38, m.barrierY, 1],
      [56, m.tipEnd, 1],
      [64, m.tipEnd, 1],
      [71, m.tipEnd, 0],
      [100, m.tipEnd, 0]
    ];
  }

  function desktopSigIn(m) {
    return [
      [0, 0, 0],
      [13, 0, 1],
      [22, m.sigBand, 1],
      [38, m.sigBand, 1],
      [56, m.sigFull, 1],
      [64, m.sigFull, 1],
      [71, m.sigFull, 0],
      [100, 0, 0]
    ];
  }

  function desktopSigAbove() {
    return [
      [0, 0, 0],
      [4, 0, 1],
      [22, 0, 1],
      [30, 0, 0],
      [100, 0, 0]
    ];
  }

  function desktopFillBar() {
    return [
      [0, 100, 0],
      [12, 100, 0],
      [13, 100, 1],
      [22, 0, 1],
      [38, 0, 1],
      [47, 0, 0],
      [100, 0, 0]
    ];
  }

  function desktopFillDeep() {
    return [
      [0, 100, 0],
      [38, 100, 0],
      [40, 100, 1],
      [56, 0, 1],
      [70, 0, 1],
      [79, 0, 0],
      [100, 0, 0]
    ];
  }

  function desktopSeal() {
    return [
      [0, 0, 0],
      [69, 0, 0],
      [71, 0, 1],
      [88, 1, 1],
      [93, 1, 1],
      [96, 1, 0],
      [100, 0, 0]
    ];
  }

  function desktopSealTip() {
    return [
      [0, 0, 0],
      [69, 0, 0],
      [71, 0, 1],
      [88, 1, 1],
      [92, 1, 0],
      [100, 1, 0]
    ];
  }

  /* ---------- Mobile m* paths (6s) ---------- */
  function mobileTip(m) {
    return [
      [0, m.tipStart, 0],
      [3, m.tipStart, 1],
      [8, m.surfaceY, 1],
      [22, m.barrierY, 1],
      [36, m.barrierY, 1],
      [58, m.tipEnd, 1],
      [66, m.tipEnd, 1],
      [72, m.tipEnd, 0],
      [100, m.tipEnd, 0]
    ];
  }

  function mobileSigIn(m) {
    return [
      [0, 0, 0],
      [7, 0, 0],
      [8, 0, 1],
      [22, m.sigBand, 1],
      [36, m.sigBand, 1],
      [58, m.sigFull, 1],
      [66, m.sigFull, 1],
      [72, m.sigFull, 0],
      [100, 0, 0]
    ];
  }

  function mobileSigAbove() {
    return [
      [0, 0, 0],
      [4, 0, 1],
      [22, 0, 1],
      [30, 0, 0],
      [100, 0, 0]
    ];
  }

  function mobileFillBar() {
    return [
      [0, 100, 0],
      [6, 100, 0],
      [8, 100, 1],
      [22, 0, 1],
      [30, 0, 1],
      [36, 0, 0],
      [100, 0, 0]
    ];
  }

  function mobileFillDeep() {
    return [
      [0, 100, 0],
      [34, 100, 0],
      [38, 100, 1],
      [58, 0, 1],
      [66, 0, 1],
      [72, 0, 0],
      [100, 0, 0]
    ];
  }

  function mobileSeal() {
    return [
      [0, 0, 0],
      [69, 0, 0],
      [70, 0, 1],
      [89, 1, 1],
      [94, 1, 1],
      [97, 1, 0],
      [100, 0, 0]
    ];
  }

  function mobileSealTip() {
    return [
      [0, 0, 0],
      [69, 0, 0],
      [70, 0, 1],
      [89, 1, 1],
      [93, 1, 0],
      [100, 1, 0]
    ];
  }

  function choreography(mobile) {
    return mobile
      ? {
          tip: mobileTip,
          sigIn: mobileSigIn,
          sigAbove: mobileSigAbove,
          fillBar: mobileFillBar,
          fillDeep: mobileFillDeep,
          seal: mobileSeal,
          sealTip: mobileSealTip,
          /* mCap1 — steps-like windows */
          cap1Blue: function (p) {
            return p >= 73 && p <= 90;
          },
          /* mCap3 */
          cap3At: function (p) {
            if (p <= 34) return CAP3_GREY;
            if (p < 40) return lerpColor(CAP3_GREY, '#ffffff', (p - 34) / 6);
            if (p <= 64) return '#ffffff';
            if (p < 70) return lerpColor('#ffffff', CAP3_GREY, (p - 64) / 6);
            return CAP3_GREY;
          },
          loopMs: 6000
        }
      : {
          tip: desktopTip,
          sigIn: desktopSigIn,
          sigAbove: desktopSigAbove,
          fillBar: desktopFillBar,
          fillDeep: desktopFillDeep,
          seal: desktopSeal,
          sealTip: desktopSealTip,
          /* skCapSeal steps(1) */
          cap1Blue: function (p) {
            return p >= 73 && p <= 93;
          },
          /* sk2Cap3 linear */
          cap3At: sampleCap3,
          loopMs: 9000
        };
  }

  function ensureEl(skin, cls, html) {
    var el = skin.querySelector('.' + cls);
    if (!el) {
      el = document.createElement('div');
      el.className = cls;
      if (html != null) el.innerHTML = html;
      skin.insertBefore(el, skin.firstChild);
    }
    return el;
  }

  function injectGuardStyles() {
    if (document.getElementById('kg-paint-js-guard')) return;
    var s = document.createElement('style');
    s.id = 'kg-paint-js-guard';
    /* Kill only the skin layers JS drives — keep word CSS lighting alive */
    s.textContent =
      '[data-kg-js-loop="1"] .kg-paint__tip,' +
      '[data-kg-js-loop="1"] .kg-paint__sig-in,' +
      '[data-kg-js-loop="1"] .kg-paint__sig-above,' +
      '[data-kg-js-loop="1"] .kg-paint__fill-bar,' +
      '[data-kg-js-loop="1"] .kg-paint__fill-deep,' +
      '[data-kg-js-loop="1"] .kg-paint__cap--1,' +
      '[data-kg-js-loop="1"] .kg-paint__cap--3,' +
      '[data-kg-js-loop="1"] .kg-paint__line--surface{' +
      'animation:none!important;}' +
      '[data-kg-js-loop="1"] .kg-paint__cap:after{' +
      'opacity:0!important;background:none!important;}';
    document.head.appendChild(s);
  }

  function initLayers(skin, m) {
    var ref = m.ref;

    var surface = ensureEl(skin, 'kg-paint__line--surface', '&nbsp;');
    surface.style.cssText =
      'position:absolute;left:0;right:0;height:1px;z-index:5;pointer-events:none;' +
      'top:' +
      m.surfaceY +
      'px;background:' +
      GREY_LINE +
      ';box-shadow:none;display:block;';

    var bline = ensureEl(skin, 'kg-paint__bline', '&nbsp;');
    bline.style.cssText =
      'position:absolute;left:0;right:0;height:1px;z-index:3;pointer-events:none;' +
      'top:' +
      m.barrierY +
      'px;background:' +
      BARRIER_LINE +
      ';display:block;';

    var fillBar = ensureEl(skin, 'kg-paint__fill-bar', '');
    fillBar.style.cssText =
      'position:absolute;left:0;right:0;z-index:1;pointer-events:none;' +
      'top:' +
      m.surfaceY +
      'px;height:' +
      m.band +
      'px;' +
      'background:linear-gradient(180deg,rgba(0,71,255,.14),rgba(0,71,255,.30));' +
      'clip-path:inset(0 0 100% 0);opacity:0;';

    var fillDeep = ensureEl(skin, 'kg-paint__fill-deep', '');
    fillDeep.style.cssText =
      'position:absolute;left:0;right:0;bottom:0;z-index:1;pointer-events:none;' +
      'top:' +
      m.barrierY +
      'px;' +
      'background:linear-gradient(180deg,rgba(0,71,255,.30),rgba(0,71,255,.64));' +
      'clip-path:inset(0 0 100% 0);opacity:0;';

    var seal = ensureEl(skin, 'kg-paint__seal', '');
    seal.style.cssText =
      'position:absolute;left:0;width:0;z-index:6;pointer-events:none;opacity:0;' +
      'top:' +
      m.surfaceY +
      'px;height:' +
      ref.sealH * m.scale +
      'px;margin-top:' +
      ref.sealMarginTop * m.scale +
      'px;' +
      'background:linear-gradient(90deg,rgba(0,71,255,.7),' +
      BLUE +
      ');' +
      'box-shadow:' +
      ref.sealGlow +
      ';';

    var sealTip = ensureEl(skin, 'kg-paint__seal-tip', '');
    var tipSz = ref.sealTipSize * m.scale;
    var half = tipSz / 2;
    sealTip.style.cssText =
      'position:absolute;left:0;z-index:7;pointer-events:none;opacity:0;border-radius:50%;' +
      'top:' +
      m.surfaceY +
      'px;width:' +
      tipSz +
      'px;height:' +
      tipSz +
      'px;margin:-' +
      half +
      'px 0 0 -' +
      half +
      'px;' +
      'background:#cfe0ff;' +
      'box-shadow:' +
      ref.sealTipGlow +
      ';';

    return {
      surface: surface,
      bline: bline,
      fillBar: fillBar,
      fillDeep: fillDeep,
      seal: seal,
      sealTip: sealTip
    };
  }

  function getSyncedT0(root) {
    try {
      var w = root.querySelector(
        '.kg-paint__word--1, .kg-paint__word--2, .kg-paint__word--3'
      );
      if (w && w.getAnimations) {
        var angs = w.getAnimations();
        if (angs.length && angs[0].startTime != null) return angs[0].startTime;
      }
    } catch (e) {
      /* ignore */
    }
    return performance.now();
  }

  function startLoop(root) {
    if (root.getAttribute('data-kg-loop-running') === '1') return;
    root.setAttribute('data-kg-loop-running', '1');

    /* Sync to word CSS timeline BEFORE disabling skin CSS animations */
    var t0 = getSyncedT0(root);

    root.setAttribute('data-kg-js-loop', '1');
    injectGuardStyles();

    var mobile = isMobile();
    var choreo = choreography(mobile);
    var loopAttr = parseFloat(root.getAttribute('data-kg-loop'));
    var LOOP_MS = mobile
      ? 6000
      : !isNaN(loopAttr) && loopAttr > 0
        ? loopAttr * 1000
        : choreo.loopMs;

    /* Keep CSS word-lighting (--loop) locked to the JS skin clock */
    var loopSec = LOOP_MS / 1000;
    root.style.setProperty('--loop', loopSec + 's');
    var scene = root.querySelector('.kg-paint__scene');
    if (scene) scene.style.setProperty('--loop', loopSec + 's');
    root.setAttribute('data-kg-loop', String(loopSec));

    var m = measure(root, mobile);
    if (!m) return;
    var layers = initLayers(m.skin, m);
    var ref = m.ref;

    var tip = root.querySelector('.kg-paint__tip');
    var sigIn = root.querySelector('.kg-paint__sig-in');
    var sigAbove = root.querySelector('.kg-paint__sig-above');

    if (tip) {
      tip.style.animation = 'none';
      tip.style.display = 'block';
      tip.style.left = ref.tipLeft;
      tip.style.width = ref.tipSize * m.scale + 'px';
      tip.style.height = ref.tipSize * m.scale + 'px';
      tip.style.marginLeft = ref.tipMargin * m.scale + 'px';
      tip.style.boxShadow = ref.tipGlow;
      tip.style.borderRadius = '50%';
      tip.style.background = BLUE;
      tip.style.zIndex = '7';
      tip.style.position = 'absolute';
    }
    if (sigIn) {
      sigIn.style.animation = 'none';
      sigIn.style.display = 'block';
      sigIn.style.top = m.surfaceY + 'px';
      sigIn.style.left = ref.sigLeft;
      sigIn.style.width = '2px';
      sigIn.style.background = BLUE;
      sigIn.style.zIndex = '6';
      sigIn.style.position = 'absolute';
    }
    if (sigAbove) {
      sigAbove.style.animation = 'none';
      sigAbove.style.display = 'block';
      sigAbove.style.top = m.tipStart + 'px';
      sigAbove.style.height = m.sigAboveH + 'px';
      sigAbove.style.left = ref.sigLeft;
      sigAbove.style.width = '2px';
      sigAbove.style.background =
        'linear-gradient(180deg,rgba(0,71,255,0),' + BLUE + ')';
      sigAbove.style.zIndex = '6';
      sigAbove.style.position = 'absolute';
    }

    var raf = 0;
    var stopped = false;

    function applyMode() {
      var nextMobile = isMobile();
      if (nextMobile === mobile) {
        m = measure(root, mobile);
        if (!m) return;
        ref = m.ref;
        layers.surface.style.top = m.surfaceY + 'px';
        layers.bline.style.top = m.barrierY + 'px';
        layers.fillBar.style.top = m.surfaceY + 'px';
        layers.fillBar.style.height = m.band + 'px';
        layers.fillDeep.style.top = m.barrierY + 'px';
        layers.seal.style.top = m.surfaceY + 'px';
        layers.seal.style.height = ref.sealH * m.scale + 'px';
        layers.seal.style.marginTop = ref.sealMarginTop * m.scale + 'px';
        layers.sealTip.style.top = m.surfaceY + 'px';
        var tipSz = ref.sealTipSize * m.scale;
        layers.sealTip.style.width = tipSz + 'px';
        layers.sealTip.style.height = tipSz + 'px';
        layers.sealTip.style.margin =
          '-' + tipSz / 2 + 'px 0 0 -' + tipSz / 2 + 'px';
        if (sigIn) sigIn.style.top = m.surfaceY + 'px';
        if (sigAbove) {
          sigAbove.style.top = m.tipStart + 'px';
          sigAbove.style.height = m.sigAboveH + 'px';
        }
        if (tip) {
          tip.style.width = ref.tipSize * m.scale + 'px';
          tip.style.height = ref.tipSize * m.scale + 'px';
          tip.style.marginLeft = ref.tipMargin * m.scale + 'px';
        }
        return;
      }
      stopped = true;
      if (raf) cancelAnimationFrame(raf);
      root.removeAttribute('data-kg-loop-running');
      startLoop(root);
    }

    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        if (!stopped) applyMode();
      }).observe(m.skin);
    }
    window.addEventListener('resize', function () {
      if (!stopped) applyMode();
    });

    if (window.matchMedia) {
      var mq = window.matchMedia(MOBILE_MQ);
      var onMq = function () {
        if (!stopped) applyMode();
      };
      if (mq.addEventListener) mq.addEventListener('change', onMq);
      else if (mq.addListener) mq.addListener(onMq);
    }

    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      if (tip) tip.style.display = 'none';
      if (sigIn) sigIn.style.display = 'none';
      if (sigAbove) sigAbove.style.display = 'none';
      layers.seal.style.display = 'none';
      layers.sealTip.style.display = 'none';
      layers.fillBar.style.opacity = '0';
      layers.fillDeep.style.opacity = '1';
      layers.fillDeep.style.clipPath = 'inset(0 0 0 0)';
      if (m.cap3) m.cap3.style.color = '#fff';
      return;
    }

    function frame(now) {
      if (stopped) return;
      var p =
        ((((now - t0) % LOOP_MS) + LOOP_MS) % LOOP_MS) / LOOP_MS * 100;

      if (tip) {
        var tv = sample(choreo.tip(m), p);
        tip.style.top = tv.v + 'px';
        tip.style.opacity = String(tv.o);
      }
      if (sigIn) {
        var sv = sample(choreo.sigIn(m), p);
        sigIn.style.height = sv.v + 'px';
        sigIn.style.opacity = String(sv.o);
      }
      if (sigAbove) {
        var av = sample(choreo.sigAbove(), p);
        sigAbove.style.opacity = String(av.o);
      }

      var fb = sample(choreo.fillBar(), p);
      layers.fillBar.style.opacity = String(fb.o);
      layers.fillBar.style.clipPath = 'inset(0 0 ' + fb.v + '% 0)';

      var fd = sample(choreo.fillDeep(), p);
      layers.fillDeep.style.opacity = String(fd.o);
      layers.fillDeep.style.clipPath = 'inset(0 0 ' + fd.v + '% 0)';

      layers.surface.style.height = '1px';
      layers.surface.style.background = GREY_LINE;
      layers.surface.style.boxShadow = 'none';

      var seal = sample(choreo.seal(), p, easeSeal);
      layers.seal.style.width = seal.v * m.panelW + 'px';
      layers.seal.style.opacity = String(seal.o);

      var st = sample(choreo.sealTip(), p, easeSeal);
      layers.sealTip.style.left = st.v * m.panelW + 'px';
      layers.sealTip.style.opacity = String(st.o);

      if (m.cap1) {
        m.cap1.style.color = choreo.cap1Blue(p) ? BLUE : CAP1_GREY;
      }
      if (m.cap3) {
        m.cap3.style.color = choreo.cap3At(p);
      }

      raf = requestAnimationFrame(frame);
    }

    raf = requestAnimationFrame(frame);
  }

  function initRoot(root) {
    startLoop(root);
  }

  function aliasFonts() {
    try {
      var faces = [];
      for (var i = 0; i < document.styleSheets.length; i++) {
        var rules;
        try {
          rules = document.styleSheets[i].cssRules;
        } catch (e) {
          continue;
        }
        if (!rules) continue;
        for (var j = 0; j < rules.length; j++) {
          var r = rules[j];
          if (r.type === 5 && /non natural grotesk/i.test(r.style.fontFamily || '')) {
            faces.push({
              src: r.style.src,
              weight: r.style.fontWeight || '400',
              style: r.style.fontStyle || 'normal'
            });
          }
        }
      }
      if (!faces.length) return;
      var css = '';
      ['NONNaturalGrotesk-Regular', 'NONNaturalGrotesk'].forEach(function (alias) {
        faces.forEach(function (f) {
          css +=
            '@font-face{font-family:"' +
            alias +
            '";src:' +
            f.src +
            ';font-weight:' +
            f.weight +
            ';font-style:' +
            f.style +
            ';font-display:swap;}';
        });
      });
      var s = document.createElement('style');
      s.setAttribute('data-kg-font-alias', '1');
      s.textContent = css;
      document.head.appendChild(s);
    } catch (e) {
      /* ignore */
    }
  }

  function boot() {
    aliasFonts();
    document.querySelectorAll('[data-kg-paint]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sec = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (!sec) return;
    var root = sec.querySelector('[data-kg-paint]');
    if (root) {
      root.removeAttribute('data-kg-loop-running');
      initRoot(root);
    }
  });
})();
